import { Component, OnInit, OnChanges, ViewChild, Input } from '@angular/core';
import { URLS } from '../..//constant/interface';

@Component({
  selector: 'icc-5g-content',
  templateUrl: './icc-5g-content.component.html',
  styleUrls: ['./icc-5g-content.component.less'],
})
export class Icc5GContentComponent implements OnInit {
  constructor() {}
  @ViewChild('cardlist', { static: false }) cardsDom: any;
  @ViewChild('btnlist', { static: false }) btnsDom: any;

  @Input() content: any;

  // 是否为纯文本内容
  isTextType: boolean;
  // 纯文本内容
  textContent: string;
  // 卡片列表
  cardList: Array<any>;
  // 悬浮菜单按钮列表
  btnList: Array<any>;

  // 鼠标是否按下
  isDown: boolean;
  // 鼠标按下时，相对视口的横向坐标位置
  screenX: number;
  // 鼠标按下后横向拖动的距离
  left = 0;

  // 同上，针对按钮组
  isBtnDown: boolean;
  btnsWidth = 0;
  btnLeft = 0;

  ngOnInit() {
    if (!this.content) {
      this.content = {
        content: '',
        contentType: 3,
        suggestions: [],
        _5GContent: [],
      };
    }
    this.packRcsPreviewData(this.content);
  }

  packRcsPreviewData(rcsContent) {
    console.log(`rcsContent`, rcsContent);
    rcsContent.contentType = '' + rcsContent.contentType;
    this.isTextType = rcsContent.contentType == '3';
    const _btnList = [];
    if (rcsContent && rcsContent.suggestions) {
      rcsContent.suggestions.forEach(suggestion => {
        _btnList.push({
          name: suggestion.text,
          param: suggestion.param,
          action: suggestion.action,
        });
      });
    }
    this.btnList = _btnList;

    let _cardLists = [];
    if (rcsContent.contentType == '1' || rcsContent.contentType == '2') {
      rcsContent._5GContent.forEach(a => {
        const arr = [];
        if (a.suggestions) {
          a.suggestions.forEach(suggestion => {
            arr.push({
              name: suggestion.text,
              param: suggestion.param,
              action: suggestion.action,
            });
          });
        }
        _cardLists.push({
          type: a.media.type == 0 ? 'img' : 'video',
          title: a.title,
          src: URLS.attachment.url + a.media.ftpUrl,
          des: a.description,
          btnGroup: arr,
        });
      });
      this.cardList = _cardLists;
    } else if (rcsContent.contentType === '3') {
      this.textContent = rcsContent.content;
    }
  }

  /* 下面的三个事件是解决5g消息多卡片横向拖拽行为 */
  onMouseDown(evt) {
    this.screenX = evt.screenX;
    this.isDown = true;
  }
  onMouseMove(evt, len) {
    if (this.isDown) {
      const diff = evt.screenX - this.screenX;
      this.screenX = evt.screenX;
      if (diff + this.left <= 0 && diff + this.left - this.cardsDom.nativeElement.offsetWidth >= -(160 + 6) * len) {
        this.left += diff;
      }
    }
    evt.stopPropagation();
  }
  onMouseUp(evt) {
    this.isDown = false;
  }

  /* 下面的三个事件是解决5g消息底部按钮组横向拖拽行为 */
  onDragDown(evt) {
    this.screenX = evt.screenX;
    this.isBtnDown = true;
    let listWidth = 0;
    const btnEls = this.btnsDom.nativeElement.getElementsByClassName('bottom-btn-item');
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < btnEls.length; i++) {
      const item: any = btnEls[i];
      listWidth += (item.offsetWidth || 0) + 8;
    }
    this.btnsWidth = listWidth;
  }
  onDragMove(evt, len) {
    if (this.isBtnDown) {
      const diff = evt.screenX - this.screenX;
      this.screenX = evt.screenX;
      if (diff + this.btnLeft <= 0 && diff + this.btnLeft - this.btnsDom.nativeElement.offsetWidth >= -this.btnsWidth) {
        this.btnLeft += diff;
      }
    }
    evt.stopPropagation();
  }
  onDragUp(evt) {
    this.isBtnDown = false;
  }

  // 处理URL的https前缀
  formatHttps(url) {
    const httpsReg = /^https:\/\//i;
    const httpReg = /^http:\/\//i;
    if (httpsReg.test(url)) {
      return url;
    } else if (httpReg.test(url)) {
      return url;
    } else {
      return 'https://' + url.replace(/^https:\/\//i, '');
    }
  }
}
